import { createApp } from 'vue'
import InputErrorWrapper from '../components/InputErrorWrapperComponent'

export default function createPageApp (options) {
  const { store, ...component } = options
  const components = { ...component.components }
  for (const template of document.querySelectorAll('template[data-vue-component]')) {
    const name = template.dataset.vueComponent
    if (!components[name]) throw new Error(`Missing component for server template: ${name}`)
    components[name] = { ...components[name], template: template.innerHTML }
    template.remove()
  }
  const app = createApp({ ...component, components })
  app.component('input-error-wrapper', InputErrorWrapper)
  if (store) app.use(store)
  return app
}
